// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"fa4ec271","453":"220f2069","806":"b6aef82f"}[chunkId] + ".chunk.js";
};